import { getStore } from "../store/store";
import { mutatorAction } from "satcheljs";

const clearPreviousNodeMutator: () => void = mutatorAction("clearPreviousFolderForestNode", (): void => {
    getStore().previousNode = undefined;
});

export default function clearPreviousNode(): void {
    clearPreviousNodeMutator();
}
